export const DEVELOPER_DASHBOARD_APP = 'DEVELOPER_DASHBOARD';

export const READ_AUDIT_LOGS = 'READ_AUDIT_LOGS';
export const READ_WEBHOOK_CONFIG = 'READ_WEBHOOK_CONFIG';
export const CREATE_WEBHOOK_CONFIG = 'CREATE_WEBHOOK_CONFIG';
export const UPDATE_WEBHOOK_CONFIG = 'UPDATE_WEBHOOK_CONFIG';
export const ARCHIVE_WEBHOOK_CONFIG = 'ARCHIVE_WEBHOOK_CONFIG';
export const READ_WEBHOOK_EVENTS = 'READ_WEBHOOK_EVENTS';
export const WRITE_WEBHOOK_EVENTS = 'WRITE_WEBHOOK_EVENTS';

/** Any DEVELOPER_DASHBOARD code (used for app-level access). */
export const ALL_WEBHOOK_PERMISSION_CODES = [
  READ_AUDIT_LOGS,
  READ_WEBHOOK_CONFIG,
  CREATE_WEBHOOK_CONFIG,
  UPDATE_WEBHOOK_CONFIG,
  ARCHIVE_WEBHOOK_CONFIG,
  READ_WEBHOOK_EVENTS,
  WRITE_WEBHOOK_EVENTS,
];
